<template lang="pug">
#selecionar-territorio
    p.mt-2 {{ $t('mensagens.laudos.selecioneUmOuMaisTerritoriosParaSolicitacaoDeLaudos') }}
    el-input.mb-3(
        :placeholder='$t("mensagens.laudos.procurePorUmTerritorioCarOuPessoaVinculada")',
        prefix-icon='el-icon-search',
        v-model='filtroSelecionarTerritorio',
        @change='findAllTerritoriosSimplificado',
        @keyup.native.enter='findAllTerritoriosSimplificado'
    )
    aviso-selecionar-territorio(:tipoLaudo='tipoLaudo')
    .conteudo(v-if='!existeRetornoSimplificadoCar')
        el-table(:data='territorios', border, style='width: 100%', @selection-change='alterarSelecao', row-key="id")
            el-table-column(
                align='center',
                type='selection',
                :reserve-selection='true',
                :selectable='canSelectRow'
            )

            el-table-column(
                prop='nome',
                :label='$t("mensagens.laudos.territorio")'
            )
                template(v-slot:default='{ row }')
                    p.m-0
                        b {{ row.nome }}
                        i.el-icon-info.enabled-icon.mx-2(
                            v-if='laudoComRestricaoTamanhoArea(row)',
                            slot='suffix',
                            :title="`${$t('mensagens.laudos.erro.areaMaiorQueLimite')} ${$t('mensagens.laudos.erro.suporteEmail')}`"
                        )

    .py-3(style='text-align: right', v-if='!existeRetornoSimplificadoCar')
        el-pagination(
            :pager-count='5',
            :page-size='pageParams.size',
            :current-page.sync='pageParams.page',
            layout='prev, pager, next',
            :total='totalTerritorios',
            @current-change='findAllTerritoriosSimplificado'
        )
    .sem-resultado(v-if='existeRetornoSimplificadoCar')
        .msg-geral
            .i.mdi.mdi-close-circle.mr-2(
                style='color: #740f0f; font-size: 18px'
            )
            .alerta-error {{ $t('mensagens.laudos.naoFoiPossivelEncontrarInformacaoInserida') }}
                br
                | {{ $t('mensagens.laudos.carNaoVinculadoAoTerritorioParaPoderSolicitarLaudo') }}
                br
                | {{ $t('mensagens.laudos.elegibilidadeRenovabio') }}.

        p {{ $t('mensagens.laudos.desejaCadastrarUmNovoTerritorio') }}?
            .botao.marginButton(slot='footer')
                el-button(
                    icon='el-icon-circle-plus-outline',
                    type='primary',
                    size='small',
                    @click='cadastrarTerritorio',
                    style='width: 100%'
                )
                    | {{ $t('mensagens.laudos.cadastrarTerritorio') }}
    el-divider.custom-divider
    .botao.marginButton(slot='footer')
        el-button.cancel-button(type='outline', @click='cancelarModal') {{ $t('mensagens.comuns.cancelar') }}
        el-button.confirm-button(
            type='primary',
            @click='enviarTerritoriosSelecionados',
            :disabled='selectedIds.length < 1'
        )
            | {{ $t('mensagens.comuns.continuar') }}
</template>

<script>
import TerritorioService from '@/services/TerritorioService';
import formatters from '@/utils/formatters';
import { ordem } from '@/utils/ordenacao';
import TipoLaudo from '@/constants/TipoLaudo';
import AvisoSelecionarTerritorio from './AvisoSelecionarTerritorio.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'SelecionarTerritorio',
    props: {
        selecionados: {
            type: Array,
            default() {
                return [];
            }
        },
        tipoLaudo: {
            type: Number,
            required: true
        }
    },

    components: {
        AvisoSelecionarTerritorio,
        BaseButton
    },

    emits: ['cancelar-modal', 'getTerritoriosSelecionados'],

    data() {
        return {
            filtroSelecionarTerritorio: '',
            territorios: [],
            territoriosSelecionados: [],
            selectedIds: [],
            checkAll: false,
            isIndeterminate: false,
            pageParams: {
                page: 1,
                size: 8
            },
            totalTerritorios: 0,
            existeRetornoSimplificadoCar: false,
            tiposLaudosCarObrigatorio: [
                TipoLaudo.AVALIACAO_SOCIOAMBIENTAL,
                TipoLaudo.CARBONO,
                TipoLaudo.CONFORMIDADE,
                TipoLaudo.RENOVABIO
            ],
            tiposLaudosAreaMaximaPermitida: [TipoLaudo.CROQUI],
            areaMaximaPermitida: 150000
        };
    },

    mounted() {
        this.ajustarJaSelecionados();

        window.addEventListener('keydown', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        });
    },

    methods: {
        canSelectRow(row) {
            if (row.totalCARs === 0 && this.tiposLaudosCarObrigatorio.includes(this.tipoLaudo)) {
                return false;
            }
            
            if (this.laudoComRestricaoTamanhoArea(row)) {
                return false;
            }
            
            return true;
        },
        alterarSelecao(rows) {
            this.territoriosSelecionados = rows;
            this.selectedIds = rows.map(row => row.id);
        },
        getFiltroSelecionarTerritorio() {
            if (this.filtroSelecionarTerritorio) {
                const cpfCnpj = formatters.documentoFormatToNumeral(
                    this.filtroSelecionarTerritorio
                );

                return cpfCnpj === ''
                    ? this.filtroSelecionarTerritorio
                    : cpfCnpj;
            }
            return '';
        },

        async findAllTerritoriosSimplificado() {
            const filtro = {};
            filtro.size = this.pageParams.size;
            filtro.page = this.pageParams.page - 1;

            try {
                const { data } =
                    await TerritorioService.findAllSimplificadoPaginado(
                        filtro,
                        this.getFiltroSelecionarTerritorio()
                    );
                this.territorios = data.content;
                this.totalTerritorios = data.totalElements;
                this.existeRetornoSimplificadoCar = false;
                this.organizar();
            } catch (err) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.laudos.ocorreuUmErroAoBuscarTerritorios'
                    )
                });
            }
        },

        organizar() {
            if (!this.territorios) {
                return;
            }

            this.territorios.sort((a, b) => ordem(a, b));
        },

        enviarTerritoriosSelecionados() {
            this.$emit('getTerritoriosSelecionados', this.territoriosSelecionados);
        },

        ajustarJaSelecionados() {
            this.selectedIds = this.selecionados.map(({ id }) => id);
            this.findAllTerritoriosSimplificado();
        },

        laudoComRestricaoTamanhoArea(territorio) {
            return (
                territorio.areaHa > this.areaMaximaPermitida &&
                this.tiposLaudosAreaMaximaPermitida.includes(
                    this.tipoLaudo
                )
            );
        },

        cancelarModal() {
            this.$emit('cancelar-modal');
        }

    }
};
</script>

<style lang="scss" scoped>
#selecionar-territorio {
    .conteudo {
        min-height: 33vh;
        max-height: 60vh;
        overflow-y: auto;
    }

    .botao {
        margin-top: 10px;
        text-align: right;
        display: flex;
        justify-content: right;

        .cancel-button {
            border: 1px solid #00413c !important;
            color: #00413c !important;
            font-size: 14px;
            height: 2.5rem;
            width: auto;
        }

        .confirm-button {
            width: 10rem;
            height: 2.5rem;
            width: auto;
            font-size: 14px;
        }
    }

    .custom-divider {
        margin-bottom: 10px;
        margin-top: 0px;
    }

    .msg-geral {
        border-radius: 5px;
        padding: 14px 5px;
        font-weight: 500;
        margin-bottom: 13px;
        border: 1px solid #de1a1a;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .alerta-error {
        margin: 5px 10px 5px 10px;
        max-width: 90%;
        text-align: left;
    }
}
</style>
